import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from 'react-redux';
import { RootState } from "../../../redux/reducers/root";
import { useDispatch } from 'react-redux';
import { changeModalState } from "../../../redux/actions/modal/modal";

import "./AmpModal.css";
import { useTranslation } from "react-i18next";

export default function AmpModal() {

    const modalState = useSelector((state: RootState) => state.modalReducer);

    const modalStatus = modalState['modalState'];

    const closeable = modalState['isCloseable'];

    const content = modalState['content'];

    const className = modalState['className'];

    const fadeOut = modalState['fadeOut'];

    const title = modalState['title'];

    const contentAriaLabel = modalState['contentAriaLabel'];

    const crossButtonAriaLabel =  modalState['crossButtonAriaLabel'];

    const translationFile = modalState['translationFile'];

    const titleKey = modalState['titleKey'];

    const contentAriaLabelKey = modalState['contentAriaLabelKey'];

    const crossButtonAriaLabelKey =  modalState['crossButtonAriaLabelKey'];

    
    const { t } = useTranslation(translationFile ?? ""); 

    const dispatch = useDispatch();

    const closeModal = () => {
        if (fadeOut) {
            dispatch(changeModalState("modal-fade-out"));
        } else {
            dispatch(changeModalState("modal-dismiss"));
        }
    }

    useEffect(() => {
        if (modalStatus === "modal-fade-in" || modalStatus=== "modal-display") {
            document.body.classList.add("modal-on")
        } else {
            document.body.classList.remove("modal-on");
        }
    }, [modalStatus]);

    return (
        <>
            <div id="ampModalBackground" className={`amp-modal-background ${modalStatus}${className ? " " + className : ""}`} onClick={() => closeable && closeModal()}>
                <div id="ampModal" className={`amp-modal ${modalStatus}`} onClick={(e) => {e.stopPropagation()}}>
                    {(title || titleKey) && <div className="amp-modal-header">
                        <h3>{titleKey ? t([titleKey], title) as string : title}</h3>
                    </div>}
                    {closeable && <button onClick={() => closeModal()} className="amp-modal-close-button" aria-label={crossButtonAriaLabelKey ? t([crossButtonAriaLabelKey], crossButtonAriaLabel) as string : contentAriaLabel}><FontAwesomeIcon className="amp-modal-close-button-font-awesome-icon" icon={faXmark} /></button>}
                    <div className="amp-modal-body" aria-label={contentAriaLabelKey ? t([contentAriaLabelKey], contentAriaLabel) as string : contentAriaLabel}>
                        {content}
                    </div>
                </div>
            </div>        
        </>
    );
}